import { useTranslate } from "@similarweb/i18n-provider";
import { Check } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

import { ONBOARDING_AGENT_FEEDBACK_COPIED, ONBOARDING_AGENT_FEEDBACK_COPY } from "../texts";

import { ReplyFeedbackCheckedIconContainer, ReplyFeedbackIconButton } from "./styles";
import { useOnboardingAgentReplyCopy } from "./hooks/useOnboardingAgentReplyCopy";

type OnboardingAgentReplyCopyButtonProps = {
    plainText: string;
    dataAutomation: string;
    messageIndex: number;
    threadId?: string;
};

export const OnboardingAgentReplyCopyButton = ({
    plainText,
    dataAutomation,
    messageIndex,
    threadId,
}: OnboardingAgentReplyCopyButtonProps) => {
    const { translate } = useTranslate();
    const { isCopied, handleCopyButtonClick } = useOnboardingAgentReplyCopy({
        plainText,
        messageIndex,
        threadId,
        translate,
    });

    return (
        <Tooltip
            content={translate(isCopied ? ONBOARDING_AGENT_FEEDBACK_COPIED : ONBOARDING_AGENT_FEEDBACK_COPY)}
            placement="bottom"
        >
            {isCopied ? (
                <ReplyFeedbackCheckedIconContainer>
                    <Check
                        size="sm"
                        color={colorsPalettes.carbon[200]}
                    />
                </ReplyFeedbackCheckedIconContainer>
            ) : (
                <ReplyFeedbackIconButton
                    type="flat"
                    iconName="copy-rounded"
                    iconSize="xs"
                    dataAutomation={dataAutomation}
                    onClick={handleCopyButtonClick}
                />
            )}
        </Tooltip>
    );
};
